/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Free_BlockedInputs */

const en_directory_submit_review_free_blocked = /** @type {(inputs: Directory_Submit_Review_Free_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission quota reached — upgrade to continue.`)
};

const zh_directory_submit_review_free_blocked = /** @type {(inputs: Directory_Submit_Review_Free_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交额度已用完 — 升级后继续。`)
};

/**
* | output |
* | --- |
* | "Submission quota reached — upgrade to continue." |
*
* @param {Directory_Submit_Review_Free_BlockedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_free_blocked = /** @type {((inputs?: Directory_Submit_Review_Free_BlockedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Free_BlockedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_free_blocked(inputs)
	return zh_directory_submit_review_free_blocked(inputs)
});
export { directory_submit_review_free_blocked as "directory.submit.review.free_blocked" }